import React from 'react';
import { Caption, Form, Title, Input, Row, Col, Divider, Select, Flex, Checkbox, Button, styled } from '@teko/ds-desktop';
import { LocationOutlined } from '@teko/ds-icon';
import { PATTERN_VALIDATION } from '@teko/utils';
import { t } from '../i18n.es.js';

const MAX_LENGTH_NOTE = 250;
const UpsertAddressFormV2 = ({
  message,
  form,
  hideFormTitle,
  requireEmail = false,
  provinces,
  wards,
  children,
  editingAddress,
  allowAddDefaultAddress,
  defaultCheckboxJustify,
  onCloseForm,
  submitForm,
  setIsDefault,
  isDefault,
  onChangeProvince,
  onChangeWard,
  dataSuggestion,
  openListSuggestion,
  onClickSuggest,
  onChangeAddress,
  isLoadingSuggest,
  hideCancelButton
}) => {
  const convertedProvinces = provinces.map(({ title, code }) => ({
    text: title,
    value: code
  }));
  const convertedWards = wards.map(({ title, code }) => ({
    text: title,
    value: code
  }));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, message.content && /* @__PURE__ */ React.createElement(Caption, {
    color: message.success ? "success500" : "error500"
  }, message.content), /* @__PURE__ */ React.createElement(Form, {
    layout: "vertical",
    form
  }, () => {
    const defaultChildren = /* @__PURE__ */ React.createElement(React.Fragment, null, !hideFormTitle && /* @__PURE__ */ React.createElement(Title, {
      level: 2
    }, t("Th\xF4ng tin ng\u01B0\u1EDDi nh\u1EADn h\xE0ng")), /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("H\u1ECD t\xEAn"),
      name: "name",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        },
        {
          pattern: /[^!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/g,
          message: t("${label} kh\xF4ng \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng")
        }
      ]
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      placeholder: t("Vui l\xF2ng nh\u1EADp t\xEAn ng\u01B0\u1EDDi nh\u1EADn")
    })), /* @__PURE__ */ React.createElement(Row, {
      justify: "space-between"
    }, /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"),
      name: "telephone",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        },
        {
          pattern: /((\+84|84|0)+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/g,
          message: t("${label} kh\xF4ng \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng")
        }
      ]
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      placeholder: t("Nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i")
    }))), /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: "Email",
      name: "email",
      rules: [
        {
          required: requireEmail,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        },
        {
          pattern: PATTERN_VALIDATION.email,
          message: t("${label} kh\xF4ng \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng")
        }
      ]
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      placeholder: t("Nh\u1EADp email c\u1EE7a b\u1EA1n")
    })))), /* @__PURE__ */ React.createElement(Divider, {
      color: "divider"
    }), /* @__PURE__ */ React.createElement(Title, {
      level: 2
    }, t("\u0110\u1ECBa ch\u1EC9 nh\u1EADn h\xE0ng")), /* @__PURE__ */ React.createElement(Row, {
      justify: "space-between"
    }, /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("T\u1EC9nh/Th\xE0nh ph\u1ED1"),
      trigger: "selectValue",
      name: "provinceCode",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        }
      ],
      validateTrigger: "selectValue"
    }, /* @__PURE__ */ React.createElement(Select, {
      options: convertedProvinces,
      value: "",
      maxPerView: 5,
      selectValue: (value) => {
        const location = provinces.find((prov) => prov.code === value);
        if (location) {
          onChangeProvince(location);
          form.setFieldsValue({
            provinceCode: location.code
          });
        }
      },
      onDelete: () => {
        form.setFieldsValue({
          provinceCode: "",
          districtCode: "",
          wardCode: ""
        });
      }
    }))), /* @__PURE__ */ React.createElement(Col, {
      flex: "49%"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("Ph\u01B0\u1EDDng/X\xE3"),
      trigger: "selectValue",
      name: "wardCode",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        }
      ],
      validateTrigger: "selectValue"
    }, /* @__PURE__ */ React.createElement(Select, {
      options: convertedWards,
      value: "",
      maxPerView: 5,
      selectValue: (value) => {
        const location = wards.find((ward) => ward.code === value);
        if (location) {
          onChangeWard(location);
          form.setFieldsValue({
            wardCode: location.code
          });
        }
      },
      onDelete: () => {
        form.setFieldsValue({
          wardCode: ""
        });
      }
    })))), /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("\u0110\u1ECBa ch\u1EC9 c\u1EE5 th\u1EC3"),
      name: "address",
      rules: [
        {
          required: true,
          message: t("${label} kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng")
        }
      ]
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      placeholder: t("S\u1ED1 nh\xE0, ng\xF5, t\xEAn \u0111\u01B0\u1EDDng..."),
      onChange: (text) => {
        onChangeAddress == null ? void 0 : onChangeAddress(text);
      }
    })), !!dataSuggestion && !!openListSuggestion && (!!dataSuggestion.length || isLoadingSuggest) && /* @__PURE__ */ React.createElement(SuggestWrapper, null, isLoadingSuggest ? /* @__PURE__ */ React.createElement(Flex, {
      justify: "center",
      align: "center"
    }, /* @__PURE__ */ React.createElement(Spinner, null)) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, {
      style: { textAlign: "left" }
    }, t("G\u1EE3i \xFD")), dataSuggestion.map((item) => {
      return /* @__PURE__ */ React.createElement(ItemSuggestion, {
        key: item.fullAddress,
        onClick: () => onClickSuggest == null ? void 0 : onClickSuggest(item.placeId)
      }, /* @__PURE__ */ React.createElement(LocationOutlined, null), /* @__PURE__ */ React.createElement(Text, {
        style: { textAlign: "left", marginLeft: 8 }
      }, item.fullAddress));
    }))), /* @__PURE__ */ React.createElement(Form.Item, {
      label: t("Ghi ch\xFA"),
      name: "addressNote",
      required: false
    }, /* @__PURE__ */ React.createElement(Input, {
      type: "text",
      maxLength: MAX_LENGTH_NOTE,
      placeholder: t("V\xED d\u1EE5: C\u1ED5ng m\xE0u xanh, nh\xE0 b\xEAn c\u1EA1nh c\xE2y x\u0103ng")
    })), !(editingAddress == null ? void 0 : editingAddress.isDefault) && !allowAddDefaultAddress && /* @__PURE__ */ React.createElement(Row, {
      justify: defaultCheckboxJustify
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      name: "isDefault",
      rules: [],
      trigger: "onChange"
    }, /* @__PURE__ */ React.createElement(Checkbox, {
      checked: isDefault,
      onChange: () => setIsDefault(!isDefault)
    }, t("\u0110\u1EB7t l\xE0m m\u1EB7c \u0111\u1ECBnh")))));
    return typeof children === "function" ? children(defaultChildren) : defaultChildren;
  }), onCloseForm && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    style: { marginTop: 40 }
  }), /* @__PURE__ */ React.createElement(BottomAction, {
    justify: "end",
    backgroundColor: "white"
  }, !hideCancelButton && /* @__PURE__ */ React.createElement(Button, {
    variant: "secondary",
    onClick: () => onCloseForm(false)
  }, t("H\u1EE7y b\u1ECF")), /* @__PURE__ */ React.createElement(Button, {
    variant: "primary",
    marginLeft: "s8",
    onClick: async () => {
      try {
        await form.validateFields();
        const res = await submitForm(form.getFieldsValue());
        onCloseForm(true, res);
      } catch (e) {
      }
    }
  }, t("L\u01B0u \u0111\u1ECBa ch\u1EC9")))));
};
const BottomAction = styled(Row)`
  position: fixed;
  bottom: 24px;
  left: 0;
  right: 24px;
  padding-top: 12px;
`;
const SuggestWrapper = styled.div`
  background-color: #fafafa;
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 15px;
  max-height: 200px;
  overflow-y: scroll;
`;
const ItemSuggestion = styled.div`
  padding: 8px 10px;
  cursor: pointer;
`;
const Text = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #434657;
`;
const Spinner = styled.div(() => `
  border: 3px solid #BBDEFB;
  border-top-color: #2196F3;
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  margin: 0 0.5rem;
  animation: spin 1s linear infinite;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`);

export { ItemSuggestion, Spinner, SuggestWrapper, UpsertAddressFormV2 };
